import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import { Serialize } from '../../services/serializeFormData'
import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'
import jsPDF from 'jspdf'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  storePaciente() {
    let self = this
    self.disableButtons(true)

    Vue.http.post(urlApiV2 + '/alunos/cadastro', Serialize.withFormData('form_psico')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarAlunos()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  store () {
    let self = this

    self.disableButtons(true)

    Vue.http.post(urlApi + '/alunos', Serialize.withFormData('form_alunos')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarAlunos()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  storeBasic () {
    let self = this

    self.disableButtons(true)

    Vue.http.post(urlApi + '/alunos/basico', Serialize.withFormData('form_alunos')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarAlunos()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  atualizarPresenca (idAluno, presencas, turma) {
    let self = this
    let presenca = '' + presencas.entrada + '-' + presencas.intervalo + '-' + presencas.saida + ''
    Vue.http.get(urlApi + '/reposicao/atualizar/presenca/' + idAluno + '/' + turma + '/' + presenca).then((response) => {
      self.launchToast('fa-check', 'Horario atualizado, informe o Desenvolvimento para envio')
    }).catch(response => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
    })
  },

  updatePaciente (idAluno) {
    let self = this
    self.disableButtons(true)
    Vue.http.post(urlApiV2 + '/alunos/consulta/update/' + idAluno, Serialize.withFormData('form_psico')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarAlunos()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  update (idAlunos) {
    let self = this
    self.disableButtons(true)
    Vue.http.post(urlApi + '/alunos/' + idAlunos, Serialize.withFormData('form_alunos')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarAlunos()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    })
  },

  atualizaStatus: function (idAlunos, status, callback) {
    let self = this

    Vue.http.patch(urlApi + '/alunos/' + idAlunos + '/' + status, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
      if (response.data.sucesso) {
        self.launchToast('fa-check', 'Status atualizado!')
      } else {
        self.launchToast('fa-check', 'Erro ao tentar atualizar o status!')
      }
      callback()
    })
  },

  getPacienteById: function (idPaciente, callback) {
    Vue.http.get(urlApiV2 + '/alunos/consulta/paciente/' + idPaciente).then(function (response) {
      callback(response)
    })
  },

  getAlunoById: function (idAlunos, callback) {
    Vue.http.get(urlApi + '/alunos/' + idAlunos).then(function (response) {
      callback(response)
    })
  },

  orderAlunoById: function (idAlunos, callback) {
    Vue.http.get(urlApi + '/alunos/' + idAlunos).then(function (response) {
      callback(response)
    })
  },

  searchCep (cep) {
    let self = this
    Vue.http.get(urlApi + '/enderecos/' + cep).then((response) => {
      if (response.status === 200 && response.data.sucesso) {
       if(typeof response.data.dados.logradouro == 'string'){
        document.getElementById('logradouro').value = response.data.dados.logradouro
       }
        document.getElementById('cidade').value = response.data.dados.municipio
        document.getElementById('uf').value = response.data.dados.uf
        if(typeof response.data.dados.bairro == 'string'){
          document.getElementById('logradouro').value = response.data.dados.logradouro
         }
      } else {
        document.getElementById('logradouro').value = ''
        document.getElementById('cidade').value = ''
        document.getElementById('uf').value = ''
        document.getElementById('bairro').value = ''
      }
    }).catch((response) => {
      // self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      document.getElementById('logradouro').value = ''
      document.getElementById('cidade').value = ''
      document.getElementById('uf').value = ''
      document.getElementById('bairro').value = ''
    })
  },

  pageListarPacientes(){
    router.push({name: 'listagem-pacientes'})
  },

  pageListarAlunos () {
    router.push({ name: 'listagem-alunos' })
  },

  paginaEdicao (idAluno) {
    router.push({ name: 'editar-aluno', params: { idAluno: idAluno } })
  },

  paginaEdit(idAluno) {
    router.push({ name: 'editar-paciente', params: { idAluno: idAluno } })
  },

  carregaFormularioDeEdicao (idAlunos) {
    Vue.http.get(urlApi + '/alunos/' + idAlunos).then((response) => {
      LoadFormData.byIdInputs(response.data.dados)
      LoadFormData.byIdInputs(response.data.dados.endereco_aluno)
      LoadFormData.byIdInputs(response.data.dados.endereco_aluno.endereco)
    })
  },

  carregaFormDeEdicao (idPaciente) {
    Vue.http.get(urlApiV2 + '/alunos/consulta/paciente/' + idPaciente).then((response) => {
      LoadFormData.byIdInputs(response.data.dados)
    })
  },

  disableButtons (status) {
    document.getElementById('btn_salvar').disabled = status
    document.getElementById('btn_limpar').disabled = status
  },

  getCategorias (callback) {
    Vue.http.get(urlApi + '/categorias').then((response) => {
      callback(response.data)
    })
  },

  getTipoCategorias (callback) {
    Vue.http.get(urlApi + '/categorias/tipos').then((response) => {
      callback(response.data)
    })
  },

  getModelos (callback) {
    Vue.http.get(urlApi + '/taxas/modelos').then((response) => {
      callback(response.data)
    })
  },

  getTaxas (callback) {
    Vue.http.get(urlApi + '/taxas/taxas').then((response) => {
      callback(response.data)
    })
  },

  launchToast (icon, msg, position = 'top-right') {
    Vue.toasted.show(msg, {
      icon: icon,
      position: position,
      duration: 5000,
      fullWidth: false
    }
    )
  },

  gerarBoleto (idAluno) {
    // console.log(idAluno);

    var doc = new jsPDF()

    doc.text('Boleto', 10, 10)
    doc.line(0, 12, 1000, 12)
    doc.line(8, 0, 8, 1000)
    doc.line(0, 290, 1000, 290)
    doc.line(200, 0, 200, 1000)

    // console.log(navigator.userAgent)
    window.open(doc.output('bloburl'))
  },

  situacaoAluno (idAluno) {
    router.push({ name: 'situacao-aluno', params: { idAluno: idAluno } })
  }
}
